import React from 'react';

interface AlarmCardProps {
  mop: string;
  count: number;
}

export default function AlarmCard({ mop, count }: AlarmCardProps) {
  const isActive = count > 0;
  const mopLower = mop.toLowerCase();

  return (
    <div className={`alarm-card ${isActive ? 'active-alarm' : 'inactive'} ${mopLower}`}>
      <div className='card-content'>
        <span className={`card-label ${mopLower}`}>{mop}</span>
        <div className='value-container'>
          <div className='value-wrapper'>
            <span className='value'>{count}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
